/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "إضافة"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "إزالة الكل"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var arAE = Object.assign(TranslationProviderComponent, {
  translations
});

export { arAE as a };
//# sourceMappingURL=ar-AE-CxXG3gd4.js.map
